const Create = () => {
  return (
    <div className="page create">
      <h2>Create</h2>
    </div>
  )
}

export default Create